// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '파마사이언스코리아',
  targetSheetName: '수수료율_26.04.21',
  headerRowIndex: 4,
  headerRowCount: 1,
  dataStartRowIndex: 5,
  fillMergedDrugNameColumn: true,
  columnMapping: {
    drugName: '제품명',
    drugCode: '보험코드 (일반약 식별코드)',
    commissionRate: '26년 3월 EDI부터 적용 수수료율',
    price: '26년 5월 보험가 (기준가)',
    commissionNote: '비고',
  },
  // 헤더 3·4열 모두 「제품명」 — 한글 제품명은 4열(병합)
  columnIndexOverrides: {
    drugName: 4,
  },
  requiredHeaders: [
    '구분',
    '성분명',
    '제품명',
    '제품명',
    '함량',
    '26년 5월 보험가 (기준가)',
    '허가사',
    '26년 3월 EDI부터 적용 수수료율',
    '26년 7월 EDI부터 적용 수수료율',
    '변경사항',
    '보험코드 (일반약 식별코드)',
    '2601_자사생동여부',
    '비고',
  ],
});
